import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { forgotPasswordapi } from "../network/Network";
import { setResetToken } from "../redux/Slices/AuthSlice";
import { useDispatch } from "react-redux";

const ForgetPassword = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const [email, setEmail] = useState("");
	const [formErrors, setFormErrors] = useState([]);
	const [loading, setLoading] = useState(false);

	//   Forgot Password Api
	const ForgotHandler = (e) => {
		e.preventDefault();
		setLoading(true);

		let isValid = true;
		const errors = {
			email: [],
		};

		// Email Validation
		if (!email) {
			errors.email.push("Email is required");
			isValid = false;
		} else if (!/\S+@\S+\.\S+/.test(email)) {
			errors.email.push("Email is invalid");
			isValid = false;
		}

		setFormErrors(errors);

		if (!isValid) {
			setLoading(false);
			return;
		}
		setFormErrors({});
		const data = { email };

		forgotPasswordapi(data)
			.then((res) => {
				Swal.fire({
					position: "center",
					icon: "success",
					title: "Your Email has been sent",
					showConfirmButton: false,
					timer: 1500,
				});

				dispatch(setResetToken(res?.data?.response?.data?.token));
				navigate("/otp", {
					state: { email },
				});
				setLoading(false);
			})
			.catch((err) => {
				const errorMessage = Array.isArray(err?.response?.data?.errors?.email)
					? err.response.data.errors.email[0]
					: err?.response?.data?.message || "Something went wrong";

				Swal.fire({
					position: "center",
					icon: "error",
					text: errorMessage,
					showConfirmButton: false,
					timer: 1500,
				});

				setLoading(false);
			});
	};

	//   =================
	return (
		<>
			<div className="main-banner-heading1">
				<Header />
			</div>
			<section className="signin">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="main-bg-signin">
								<h2 className="main-heading level-2 text-center mt-3 mb-3 main-heading-font dark-color wow animate__animated animate__zoomIn">
									Forgot Password{" "}
								</h2>
								<div className="row">
									<div className="col-lg-12 mb-2">
										<div className="form-group">
											<h5 className="primary-medium-font level-7 ">Email</h5>
											<input
												type="email"
												value={email}
												name="email"
												onChange={(e) => setEmail(e.target.value)}
												className="form-control"
												placeholder="Enter your Email Address"
											/>
											<p className="forms-error">{formErrors?.email}</p>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<Link className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none">
											<span
												onClick={(e) => ForgotHandler(e)}
												className="loading-btn loading bg-wrapper w-100"
											>
												{loading ? <i className="fa fa-spinner"></i> : "Submit"}
											</span>
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default ForgetPassword;
